import { VesDamageKostenbelegModel } from "../view/VesDamageKostenbeleg";
import { UploadContainerModel } from "../view/UploadContainer";
import { SchadenmeldungUploadDatenExtendedApi } from "../generated/SchadenmeldungSchadenmeldungUploadDatenExtendedApi";
import { SchadenmeldungUploadDatenApi } from "../generated/SchadenmeldungSchadenmeldungUploadDatenApi";
import { SchadenmeldungKostenPositionApi } from "../generated/SchadenmeldungSchadenmeldungKostenPositionApi";
import { SchadenmeldungKostenRequestApi } from "../generated/SchadenmeldungSchadenmeldungKostenRequestApi";
import { TarifartKostenApi } from "../generated/SchadenmeldungTarifartKostenApi";


export class DamageDeclarationAdapter {

	/**
	 * Converts view and upload model to an api model.
	 */
	public static getUploadDataCostType(belege: { [id: string]: VesDamageKostenbelegModel }, uploadContainer: UploadContainerModel): Array<SchadenmeldungUploadDatenExtendedApi> {
		const uploadDaten: Array<SchadenmeldungUploadDatenExtendedApi> = [];

		if (belege && uploadContainer && uploadContainer.Files) {
			uploadContainer.Files.forEach((file) => {
				const uploadDatenApiModel = new SchadenmeldungUploadDatenExtendedApi();

				const costData = belege[file.FileGuid];
				if (costData) {
					uploadDatenApiModel.Betrag = costData.Betrag;
					uploadDatenApiModel.Waehrung = costData.WaehrungKuerzel;
					uploadDatenApiModel.FileId = file.FileGuid;
					uploadDatenApiModel.Filename = file.FileName;
					uploadDatenApiModel.Filesize = file.FileSize;
					uploadDaten.push(uploadDatenApiModel);
				}

			});
		}
		return uploadDaten;
	}

	/**
	 * Converts upload model to an api model.
	 */
	public static getUploadData(uploadContainer: UploadContainerModel): Array<SchadenmeldungUploadDatenApi> {
		const uploadDaten: Array<SchadenmeldungUploadDatenApi> = [];

		if (uploadContainer && uploadContainer.Files) {
			uploadContainer.Files.forEach((file) => {
				const uploadDatenApiModel = new SchadenmeldungUploadDatenApi();

				uploadDatenApiModel.FileId = file.FileGuid;
				uploadDatenApiModel.Filename = file.FileName;
				uploadDatenApiModel.Filesize = file.FileSize;
				uploadDaten.push(uploadDatenApiModel);
			});
		}
		return uploadDaten;
	}

	public static getKostenSummenRequest(tarif: TarifartKostenApi, kostenSummen: { [id: string]: string }): SchadenmeldungKostenRequestApi {
		const apiModel = new SchadenmeldungKostenRequestApi();
		apiModel.Tarif = tarif;
		apiModel.Schadenkosten = new Array<SchadenmeldungKostenPositionApi>();

		Object.keys(kostenSummen).forEach((key) => {
			const costRequest: SchadenmeldungKostenPositionApi = new SchadenmeldungKostenPositionApi();
			costRequest.Betrag = parseFloat(kostenSummen[key].replace(',', '.'));
			costRequest.Code = key;
			apiModel.Schadenkosten.push(costRequest);
		});

		return apiModel;
	}
}